var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.75 55C44.7957 55 53.75 46.0457 53.75 35C53.75 23.9543 44.7957 15 33.75 15C22.7043 15 13.75 23.9543 13.75 35C13.75 46.0457 22.7043 55 33.75 55Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.75 51.25C42.7246 51.25 50 43.9746 50 35C50 26.0254 42.7246 18.75 33.75 18.75C24.7754 18.75 17.5 26.0254 17.5 35C17.5 43.9746 24.7754 51.25 33.75 51.25Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.25 45C37.2957 45 46.25 36.0457 46.25 25C46.25 13.9543 37.2957 5 26.25 5C15.2043 5 6.25 13.9543 6.25 25C6.25 36.0457 15.2043 45 26.25 45Z",
    fill: "url(#paint0_linear_649_15298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.25 41.25C35.2246 41.25 42.5 33.9746 42.5 25C42.5 16.0254 35.2246 8.75 26.25 8.75C17.2754 8.75 10 16.0254 10 25C10 33.9746 17.2754 41.25 26.25 41.25Z",
    fill: "#F5BE00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.8113 32.9312H21.5776V30.1124H24.9288V20.0362L21.4863 20.7812V17.8937L28.4813 16.4824V30.1124H31.8101L31.8113 32.9312Z",
    fill: "#FEE119"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_15298",
    x1: 12.5225,
    y1: 11.2725,
    x2: 40.3625,
    y2: 39.1125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.b23ed67504f97c36d18fa909b6185780.svg";
export { ForwardRef as ReactComponent };